import styled from 'styled-components';
import { useAccount } from 'wagmi';
import { Heading, Flex, FlexLayout, Loading, Pool, ViewMode } from '@pancakeswap/uikit';
import { useTranslation } from '@pancakeswap/localization';
import { usePoolsPageFetch, usePoolsWithVault } from 'state/pools/hooks';
import Page from 'components/Layout/Page';
import ConnectWalletButton from 'components/ConnectWalletButton';
import { Token } from '@pancakeswap/sdk';
import { TokenPairImage } from 'components/TokenImage';
import { useUserPoolsViewMode } from 'state/user/hooks';
import { useActiveChainId } from 'hooks/useActiveChainId';
import { findToken } from '@pancakeswap/tokens';
import CardActions from './components/PoolCard/CardActions';
import AprRow from './components/PoolCard/AprRow';
import CardFooter from './components/PoolCard/CardFooter';
import CakeVaultCard from './components/CakeVaultCard';
import PoolControls from './components/PoolControls';
import PoolRow, { VaultPoolRow } from './components/PoolsTable/PoolRow';



const CardLayout = styled(FlexLayout)`
  justify-content: stretch;
`;

const Pools: React.FC<React.PropsWithChildren> = () => {
  const { t } = useTranslation();
  const { chainId } = useActiveChainId();
  const { address: account } = useAccount();
  let { pools } = usePoolsWithVault();
  const { userDataLoaded } = usePoolsWithVault();
  const [vMode] = useUserPoolsViewMode();

  
  usePoolsPageFetch();

  pools = pools.filter(pool => pool.sousId < 1000);

  return (
    <>
      <Page>
        <Heading as="h1" scale="xxl" color="secondary" mb="24px">
          {t('9INCH Staking')}
        </Heading>

        <div style={{
          borderRadius: '25px',
          width: '100%',
          background: vMode === ViewMode.TABLE ? 'linear-gradient(90deg, #180110 0%, #160110 50%, #140110 100%)' : 'transparent',
          border: vMode === ViewMode.TABLE ? '1px solid rgb(93, 92, 93)' : 'none',
          boxShadow: vMode === ViewMode.TABLE ? 'rgb(255, 255, 255) 0px 2px 8px' : 'none',
          display: 'flex',
          flexDirection: 'column'
        }}>
          <PoolControls pools={
            pools.map(pool => ({
              ...pool,
              stakingToken: findToken(pool.stakingToken.symbol, chainId),
              earningToken: findToken(pool.earningToken.symbol, chainId),
            }))
          }>
            {({ chosenPools, viewMode, stakedOnly, normalizedUrlSearch }) => (
              <>
                {account && !userDataLoaded && stakedOnly && (
                  <Flex justifyContent="center" mb="4px">
                    <Loading />
                  </Flex>
                )}
                {viewMode === ViewMode.CARD ? (
                  <CardLayout>
                    {chosenPools.filter(poolConfig => !!poolConfig.contractAddress[chainId]).map((pool) =>
                      pool.vaultKey ? (
                        <CakeVaultCard key={pool.vaultKey} pool={pool} showStakedOnly={stakedOnly} />
                      ) : (
                        <Pool.PoolCard<Token>
                          key={pool.sousId}
                          pool={pool}
                          isStaked={Boolean(pool?.userData?.stakedBalance?.gt(0))}
                          cardContent={
                            account ? (
                              <CardActions pool={pool} stakedBalance={pool?.userData?.stakedBalance} />
                            ) : (
                              <ConnectWalletButton />
                            )
                          }
                          tokenPairImage={
                            <TokenPairImage
                              primaryToken={pool.earningToken}
                              secondaryToken={pool.stakingToken}
                              width={64}
                              height={64}
                            />
                          }
                          cardFooter={<CardFooter pool={pool} account={account} />}
                          aprRow={<AprRow pool={pool} stakedBalance={pool?.userData?.stakedBalance} />}
                        />
                      ),
                    )}
                  </CardLayout>
                ) : (
                  <Pool.PoolsTable>
                    {chosenPools.filter(poolConfig => !!poolConfig.contractAddress[chainId]).map((pool) =>
                      pool.vaultKey ? (
                        <VaultPoolRow
                          initialActivity={normalizedUrlSearch.toLowerCase() === pool.earningToken.symbol?.toLowerCase()}
                          key={pool.vaultKey}
                          vaultKey={pool.vaultKey}
                          account={account}
                        />
                      ) : (
                        <PoolRow
                          initialActivity={normalizedUrlSearch.toLowerCase() === pool.earningToken?.symbol?.toLowerCase()}
                          key={pool.sousId}
                          sousId={pool.sousId}
                          account={account}
                        />
                      ),
                    )}
                  </Pool.PoolsTable>
                )}
              </>
            )}
          </PoolControls>
        </div>
      </Page>
    </>
  )
}

export default Pools;
